// extracted by mini-css-extract-plugin
module.exports = {"alert":"RootError_alert","alertDanger":"RootError_alertDanger","root":"RootError_root","inPageLink":"RootError_inPageLink","returnLink":"RootError_returnLink"};